import { render } from "./OrderListView.vue?vue&type=template&id=a0e84436&scoped=true"
import script from "./OrderListView.vue?vue&type=script&lang=js"
export * from "./OrderListView.vue?vue&type=script&lang=js"

import "./OrderListView.vue?vue&type=style&index=0&id=a0e84436&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e84436"]])

export default __exports__